import moment from "moment";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import useSWR from "swr";
import { API } from "../../../StoreComponents/conflict";
const fetcher1 = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);

const SingleViewRequisition = () => {
  const { view_id } = useParams();

  const [pageIndex, setPageIndex] = useState(0);
  const [search, setSearch] = useState("");
  // get View Requisition
  const {
    data: viewSingleRequisition,
    error: error1,
    mutate,
  } = useSWR(view_id ? `store/requisition/details/${view_id}` : null, fetcher1);

  console.log(viewSingleRequisition);
  const navigate = useNavigate();

  let count = 1;

  return (
    <>
      <Helmet>
        <title>View Requisition Details - BBA STORE</title>
        <meta
          name="description"
          content="View Requisition Details - BBA STORE"
        />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>

      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex justify-content-between">
            <div>
              <button
                onClick={() => navigate(-1)}
                class="btn btn-o ms-1 mb-3"
                style={{
                  background: "#000",
                  color: "#fff",
                  borderRadius: "10px",
                }}
              >
                <i class="fa fa-hand-o-left"></i> Back
              </button>
            </div>
            <div></div>
          </div>
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">View Requisition Details</h3>
          </div>
          {!viewSingleRequisition ? (
            <div className="d-flex justify-content-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div
              className="my-4 table-container p-2"
              style={{ background: "white", borderRadius: "10px" }}
            >
              <div>
                <h4 className="text-white py-2 text-center tableColor">
                  Product Requisition Details
                </h4>
                <div className="mb-5">
                  <div className="row gx-5">
                    <div className="col-sm-3">
                      <div className="ps-3 pt-3 fs-5">
                        Requisition Date & Time :
                      </div>
                    </div>
                    <div className="col-sm-9">
                      <div className="ps-3 pt-3">
                        <b>
                          {moment(
                            new Date(viewSingleRequisition.info.DATE_TIME)
                          ).format("LT , DD-MM-YYYY")}
                        </b>
                      </div>
                    </div>
                  </div>
                  <div className="row gx-5">
                    <div className="col-sm-3">
                      <div className="ps-3 pt-3 fs-5">
                        Requisition Approved Status :
                      </div>
                    </div>
                    <div className="col-sm-9">
                      <div className="ps-3 pt-3">
                        <b>
                          <span className="bg-success text-white px-3 py-1 rounded-3">
                            {viewSingleRequisition.info.Status}
                          </span>
                        </b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-responsive ">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr className="text-center tableColor">
                      <th>S/N</th>
                      <th>Product</th>
                      <th>Requisition</th>
                      <th>Approved</th>
                      <th>Unit</th>
                      <th>User Remarks</th>
                      <th>Admin Remarks</th>
                      <th>Store Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {viewSingleRequisition.products.map((product) => (
                      <tr key={count}>
                        <th className="text-center">{count++}</th>
                        <td>{product.PRODUCT_NAME}</td>
                        <td className="text-center">{product.PROREQUQTY}</td>
                        <td className="text-center">{product.APROQTY}</td>
                        <td>{product.UNIT}</td>
                        <td>{product.PREMARKS}</td>
                        <td>{product.APPROVEREMARKS}</td>
                        <td>
                          {product.STOREREMARKS === "undefined"
                            ? ""
                            : product.STOREREMARKS}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SingleViewRequisition;
